import React from 'react';
import PropTypes from 'prop-types';

function Column({ value, className, style }) {
  return (
    <div className={className} style={style}>{value}</div>
  )
}

Column.propTypes = {
  value: PropTypes.any.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
}

export default Column;
